import { useEffect, useState } from "react";
import { Table, Space } from "antd";
import { useRequest } from "ahooks";
import { setting as settingService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import DeductPointAddButton from "./DeductPointAddButton";
import DeductPointEditButton from "./DeductPointEditButton";
import DeductPointDeleteButton from "./DeductPointDeleteButton";

import styles from "./index.module.less";

function DeductPoint() {
  const [version, setVersion] = useState(Date.now());
  const auth = useAuthContext();
  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return settingService.listDeductPoint(params, token);
    },
    {
      manual: true,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          version,
          page: 1,
          page_size: 50,
        },
        auth.token
      );
    }
  }, [run, auth, version]);

  const columns = [
    {
      title: "序号",
      key: "num",
      width: 100,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "名称",
      dataIndex: "name",
    },
    {
      title: "分值",
      dataIndex: "value",
    },
    {
      title: "操作",
      key: "operate",
      width: 120,
      render: (record) => (
        <Space>
          <DeductPointEditButton
            deductPointId={record.id}
            token={auth.token}
            callback={setVersion}
          />
          <DeductPointDeleteButton
            deductPointId={record.id}
            token={auth.token}
            callback={setVersion}
          />
        </Space>
      ),
    },
  ];
  return (
    <div className={styles.deductPoint}>
      <div className="table-toolbar">
        <div className="left">
          <DeductPointAddButton token={auth.token} callback={setVersion} />
        </div>
        <div className="right"></div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={false}
      />
    </div>
  );
}

export default DeductPoint;
